import { Policy } from "@/interfaces/roles";
import { MutationTree } from "vuex";
import PermissionState from "./permission.types";

type PermissionMutationTree = MutationTree<PermissionState>;

export const mutations: PermissionMutationTree = {
  setPolicies(state, policies: Policy[]) {
    state.policies = policies;
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
};

export default mutations;
